//
//
//
//
//
//
//

import { defineComponent } from '@nuxtjs/composition-api';
import MoominBenefitBar from '~/themes/fiskarsMoominDefault/components/components/molecules/MoominBenefitBar/MoominBenefitBar.vue';
export default defineComponent({
  name: "MoominBenefitBarCms",
  components: { MoominBenefitBar },
  props: {
    items: {
      type: Array,
      default: () => [],
    }
  },
  data() {
    return {
      newItems: [],
    }
  },
  methods: {
    parseResponse(before, after) {
      before.forEach(item => {
        after.push({
        "title": item.benefits.title,
        "description": item.benefits.subTitle,
        "link": item.benefits.link,
        "image": item.benefits.image
        })
      })
    }
  },
  created() {
    this.parseResponse(this.items, this.newItems);
  }
 });
